// Esports subdomain detection.
//
// StatHarbour serves two verticals from one build, routed by hostname:
//   - Sports:  statharbour.com (marketing/app) + demo.statharbour.com (demo)
//   - Esports: esports.statharbour.com (marketing/app) + demo.esports.statharbour.com (demo)
//
// This mirrors isDemoHost in src/config/demo.ts. The root route in src/App.tsx
// checks these helpers to decide what to render at "/". Order matters there:
// demo.esports.* also starts with "demo." (so it satisfies isDemoHost), so the
// esports-demo check must run before the sports-demo check.

/**
 * Returns true when the app is served from the esports vertical host
 * (for example esports.statharbour.com or esports.localhost). Note that
 * demo.esports.* starts with "demo." and is intentionally NOT matched here,
 * see isEsportsDemoHost.
 */
export function isEsportsHost(hostname: string): boolean {
  return hostname === "esports.statharbour.com" || hostname.startsWith("esports.");
}

/**
 * Returns true when the app is served from the esports demo host
 * (for example demo.esports.statharbour.com or demo.esports.localhost).
 */
export function isEsportsDemoHost(hostname: string): boolean {
  return (
    hostname === "demo.esports.statharbour.com" || hostname.startsWith("demo.esports.")
  );
}

/**
 * Where a signed-in organizer lands when nothing more specific was asked for:
 * the esports dashboard on an esports host, the sports dashboard everywhere
 * else. Login, signup and the signup confirmation email all read it, so an
 * esports organizer is never dropped on the sports dashboard or its pricing
 * page (esports has no billing).
 */
export function defaultSignedInPath(hostname: string): string {
  return isEsportsHost(hostname) || isEsportsDemoHost(hostname) ? "/esports/dashboard" : "/dashboard";
}
